import { Paths } from "src/navigation";

// Maps here the product codes
export enum ProductsCodeMap {
  RC01 = "RC_01",
  TL01 = "TL_01",
  US01 = "US_01",
}

/**
 *
 * @param code string - product code
 * @returns  string - path to product landing page
 *
 * This function maps product codes to their respective landing page paths.
 * If the product code does not match any known codes, it returns the path to the 404 error page.
 */
export function getProductPathFromCode(code: string): string {
  switch (code) {
    case ProductsCodeMap.RC01:
      return Paths.ProductLandingRC;
    case ProductsCodeMap.TL01:
      return Paths.ProductLandingTL;
    case ProductsCodeMap.US01:
      return Paths.ProductLandingUS;

    default:
      return Paths.Error404;
  }
}
